import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleYesterdaysPerformanceHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type YesterdaysPerformanceCardProps = {
  titleHref: string
  performance: HuddleDashboard['yesterdaysPerformanceApi']
  className?: string
}

export function YesterdaysPerformanceCard({
  titleHref,
  performance,
  className = 'dashboard-huddle-yesterday-card',
}: YesterdaysPerformanceCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = performance
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleYesterdaysPerformanceHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Yesterday's Performance"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
